module.exports = __webpack_public_path__ + "static/media/checkbox_on.4ba3088a.svg";